<template>
  <a-form :form="form">
    <a-row :gutter="16">
      <a-col :xs="{ span: 24 }" :lg="{ span: 24 }">
        <a-form-item label="No UM PD">
          <a-select
            :disabled="active || mode === 'Edit'"
            showSearch
            placeholder="Select No. UM"
            @change="handleNo"
            v-decorator="[
              'no_um',
              { rules: [{ required: true }], initialValue: initialData.no_um },
            ]"
          >
            <a-select-option v-for="item in getLapListUM" :key="item.no_um">{{
              item.no_um
            }}</a-select-option>
          </a-select>
        </a-form-item>
        <div class="container-essential">
          <ul style="list-style: none;padding-inline-start: 0px;">
            <li>
              <div class="ant-form-item" for>Assignee :</div>
              <small><span class="m-list-desc" v-for="(items, index) in assignee" :key="items.tlc">
                {{index+1}}. {{items.tlc}}-{{items.nama}} <br/> &nbsp;&nbsp;&nbsp;&nbsp;({{ items.kategori }};
                {{
                  initialData.no_um.includes("PD.ITS") ? "Ins. SPPD:"+ formatCurrency('IDR', items.ins_sppd) +" | Ins. SPPD LN:"+ formatCurrency('USD', items.ins_sppd_ex)  : 
                  (initialData.no_um.includes("PD.ITS") ? "Ins. SPPS:"+items.ins_spps+"%" : "-")
                }})
              </span></small>
            </li>
          </ul>
        </div>
        <a-form-item label="Reporting Date">
          <a-date-picker
            placeholder="Select Date"
            disabled
            :format="getDefaultDateFormat"
            v-decorator="[
              'tanggal_pelaporan',
              {
                rules: [{ required: true }],
                initialValue: initialData.tanggal_pelaporan,
              },
            ]"
          />
        </a-form-item>
        <a-form-item label="Category">
          <a-radio-group
            buttonStyle="solid"
            v-decorator="['isparsial', {rules: [{required: true,message: 'Category is required!'}], initialValue: initialData.isparsial}]"
          >
            <a-radio-button value="1"> Parsial </a-radio-button>
            <a-radio-button value="0"> Final </a-radio-button>
          </a-radio-group>
        </a-form-item>
        <div style="display:none">
        <a-form-item label="Vice President Finance">
          <a-input
            disabled
            v-decorator="[
              'bod',
              { rules: [{ required: true }], initialValue: initialData.bod },
            ]"
          ></a-input>
        </a-form-item>
        </div>
      </a-col>
    </a-row>
  </a-form>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import axios from "axios";
import moment from "moment";
import CurrencyFormat from "@/mixins/CurrencyFormat";

export default {
  name: "informasiLaporanUmpd",
  props: {
    data: {},
    others: {},
    mode: String,
    type: String,
    active: false,
  },
  mixins: [CurrencyFormat],
  data() {
    return {
      pageLoading: true,
      assignee:[],
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  created() {
    if (this.mode === "Create" && this.getLapListUM[0].assignee.length>0) {
      this.assignee = this.getLapListUM[0].assignee
    }else{
      this.assignee = this.others.assignee
    }
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getStandartFormatDate",
      "getLapListUM",
    ]),
    initialData() {
      if (this.data === undefined || this.data.length <= 0) {
        return {
          no_um: [],
          tanggal_pelaporan: moment(),
          bod: "",
          peruntukan: "",
          isparsial: "1",
          catatan : "",
        };
      } else {
        let peruntukan = "";
        if (this.mode === "Create") {
          peruntukan = this.data.peruntukan;
        } else {
          peruntukan = this.others.peruntukan;
        }
        return {
          no_um: this.data.no_um,
          tanggal_pelaporan: moment(this.data.tanggal_pelaporan),
          bod: this.data.bod,
          peruntukan: peruntukan,
          isparsial: this.data.isparsial,
          catatan : this.data.catatan,
        };
      }
    },
  },
  methods: {
    moment,
    handleNo(e) {
      let data = {};
      data = this.getLapListUM.filter(
        (obj) => obj.no_um.toLowerCase().indexOf(e.toLowerCase()) >= 0
      );

      this.initialData.bod = data[0].bod + " - " + data[0].nama_bod;
      this.initialData.peruntukan = data[0].peruntukan;
      this.initialData.id_um = data[0].id_um;
      this.initialData.no_um = data[0].no_um;
      this.initialData.isparsial = data[0].isparsial;
      this.assignee = data[0].assignee;
      this.form.setFieldsValue({
        bod: this.initialData.bod,
      });
    },
    handleRef() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        let idUm = "";
        if (this.mode == "Create") {
          this.handleNo(values.no_um);
          idUm = this.initialData.id_um;
        } else {
          idUm = this.data.id_um;
        }

        const informasi = {
          tanggal_pelaporan: values.tanggal_pelaporan,
          no_um: values.no_um,
          id_um: idUm,
          bod: values.bod || "",
          peruntukan: this.initialData.peruntukan || "",
          isparsial: values.isparsial,
          catatan : this.initialData.catatan
        };

        Event.$emit("lapUmpd", informasi);
      });
    },
    clearForm() {
      this.form.resetFields();
    },
  },
  watch: {
    "others"() {
      if(this.others.assignee){
        this.assignee = this.others.assignee
      }
    }
  }
};
</script>

<style></style>
